export default "__VITE_ASSET__R$2NCuaw__"